// extracted by mini-css-extract-plugin
export default {"DeleteOrderModal":"DeleteOrderModal_DeleteOrderModal__ZBqjQ","buttons":"DeleteOrderModal_buttons__BetGk"};